<template>
	<div>
		<div v-if="error" class="alert alert-danger">{{error}}</div>
		<form class="form">
			<div class="form-group">
				<label for="key">Name</label>
				<input type="text" id="key" class="form-control" v-model="formBonus.key" placeholder="Name" />
			</div>
			<div class="form-group">
				<label for="cents">Cents</label>
				<input type="number" id="cents" class="form-control" v-model="formBonus.cents" placeholder="Cents" />
			</div>
		</form>
		<div class="form-group mt-5 text-right">
			<button class="btn btn-secondary mr-2" @click="cancel">Cancel</button>
			<button class="btn btn-primary" @click="save">
				<span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>Save
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "BonusEdit",
	props: ["bonus", "error", "loading"],
	data() {
		return {
			formBonus: Object.assign({}, this.bonus)
		}
	},
	methods: {
		save: function () {
			this.$emit("request-save", this.formBonus);
		},
		cancel: function () {
			this.$emit("close");
		},
	},
};
</script>

<style>
</style>